module.exports = __webpack_public_path__ + "img/firenze_the_centaur.6f74abaf.jpg";